<template>
  <fieldset class="fieldset">
    <legend class="legend" :class="requiredClass">
      <slot name="legend"></slot>
    </legend>
    <input :id="idName" v-bind:class="[{ 'error-field': !!errors }, 'input-field']" :type="inputType" :name="inputName" :placeholder="placeholder">
    <ul v-if="!!errors" class ="form-error">
      <li v-for="(error, index) in errors" :key="index" class="form-error-item">
        {{ error }}
      </li>
    </ul>
  </fieldset>
</template>

<script>
import requirable from '@/form/requirable'

export default {
  name: 'SingleInputField',
  mixins: [
    requirable
  ],

  props: {
    inputType: {
      type: String,
      required: true
    },

    inputName: {
      type: String,
      required: true
    },

    placeholder: {
      type: String,
      required: false,
      default: ''
    },

    idName: {
      type: String
    },

    errors: {
      type: Array,
      required: false
    }
  }
}
</script>
